import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { type HistoryList, type OldResponse } from "@/types";

import TypewriterMarkdown from "@/components/TypewriterMarkdown";

import { ArrowsPointingInIcon, ArrowsPointingOutIcon, MagnifyingGlassIcon } from "@heroicons/react/16/solid";
import { ChevronDown, ChevronRight } from "lucide-react";
import Logo from "@/assets/home/logo.svg?react";
import { Button } from "@/components/ui/button.tsx";
import { aiApi } from "@/api/aiApi.ts";
import { useTranslation } from "@/locales";

export const ThreadPage = () => {
  const { threadId } = useParams<{ threadId: string }>();
  const hasFetched = useRef(false);
  const { t } = useTranslation();

  const [list, setList] = useState<OldResponse>({
    records: [],
    topicName: "",
    topicNo: "",
  });

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const fetchData = async () => {
      console.log(threadId);
      if (threadId) {
        try {
          const response = (await aiApi.conversation.getShareLink(threadId)) as OldResponse;
          setList(response);
          document.title = response.topicName as string;
          hasFetched.current = false;
        } catch (error) {
          hasFetched.current = false;
          console.error("获取分享链接失败:", error);
        }
      }
    };
    fetchData();
  }, []);
  const historyThink = (event: HistoryList, index: number) => {
    const changeOpen = () => {
      setList((prev) => {
        if (!prev.records) return prev;

        const newRecords = [...prev.records];
        newRecords[index] = {
          ...newRecords[index],
          isOpen: !newRecords[index].isOpen,
        };

        return { ...prev, records: newRecords };
      });
    };
    const thinksStop = event.stopReason != "COMPLETE" && !event.answer && event.reasoning.length > 0;

    if (event.isOpen) {
      return (
        <div className="pt-0 ai overflow-hidden bg-[var(--background)]">
          <div className={"think-button-collapse collapse-collapse-button-Lf stick-LY h-full min-h-[24px]"}>
            <div
              className="flex justify-between items-center w-full"
              onClick={(e) => {
                e.stopPropagation();
                changeOpen();
              }}
            >
              <div className="think-block-title">{thinksStop ? t("thinking_stopped") : t("thinking_completed")}</div>
              <Button variant="outline" className="z-10 text-[22px] h-[28px] w-[28px]">
                <ArrowsPointingInIcon />
              </Button>
            </div>
          </div>
          {/*<div className={"think think-container"}*/}
          {/*     style={{maxHeight: '100%'}}>*/}
          {/*    <div className="content think-content">*/}
          {/*        <TypewriterMarkdown*/}
          {/*            content={event.reasoning}*/}
          {/*            speed={10}*/}
          {/*            citations={event.citations}*/}
          {/*            docs={event.files}*/}
          {/*            conversationNo={event.conversationNo}*/}
          {/*        />*/}
          {/*    </div>*/}
          {/*</div>*/}
          {/*<div ref={bottomRef}/>*/}
        </div>
      );
    } else {
      return (
        <Button
          variant="outline"
          onClick={(e) => {
            e.stopPropagation();
            changeOpen();
          }}
        >
          <div>
            <span>{thinksStop ? t("thinking_stopped") : t("thinking_completed")}</span>
          </div>
          <ArrowsPointingOutIcon />
        </Button>
      );
    }
  };
  const toHome = () => {
    window.location.href = `#/${list.topicNo}`;
  };

  return (
    <div className={"bg-background flex-1 flex h-[100vh]"}>
      <div className="flex-1 flex overflow-hidden">
        <div className="flex-1">
          <div className="ai-chat-container flex-1  bg-background px-4 pt-6 pb-1.5 flex justify-between flex-col">
            <div className={"scroll-container flex-1 w-full overflow-y-auto pl-auto pr-auto flex flex-col items-center "}>
              <div className="messages">
                {list.records?.map((record, index) => {
                  return (
                    <div key={record.conversationNo} className="conversation-group mb-5">
                      {/* 问题展示 */}
                      <div className={"flex justify-end flex-1"}>
                        <div className={"flex-1"}>
                          <div className="question-text">
                            <div className="question-text-content">{record.query}</div>
                          </div>
                        </div>
                      </div>
                      <div className={"flex justify-between flex-1"}>
                        <div className={"flex-1"}>
                          {/* 渲染事件 */}
                          {/*{record.reasoning.length > 0 ? (*/}
                          {/*    <div className={''}>*/}
                          {/*        {historyThink(record, index)}*/}
                          {/*    </div>*/}
                          {/*) : ''*/}
                          {/*}*/}
                          <div className="message answer">
                            <div className="content answer-content">
                              <TypewriterMarkdown content={record.answer} speed={10} conversationNo={record.conversationNo} />
                            </div>
                          </div>
                          {
                            // <div
                            //     className={'mx-[var(--mini-thread-content-inset)]'}>
                            //     <div className='flex min-h-[46px] justify-start'>
                            //         <div
                            //             className={' flex flex-wrap items-center gap-y-4 p-1 '}>
                            //
                            //             {record.files.length > 0 ? <span
                            //                 className="file-multi-info"
                            //                 onClick={()=>{}}>
                            //             <div
                            //                 className='file-text py-[3px] px-[8px] cursor-pointer flex items-center'>
                            //                 <MagnifyingGlassIcon
                            //                     className='w-[14px] h-[14px] mr-[6px]'></MagnifyingGlassIcon>
                            //                 {record.files.length} 条资料
                            //                 <ChevronRight
                            //                     className='w-[14px] h-[14px]  ml-[6px]'/>
                            //             </div>
                            //         </span> : ''
                            //             }
                            //         </div>
                            //     </div>
                            // </div>
                          }
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <div className="inner">
                <div
                  className={"to-bottom-button"}
                  style={{
                    backgroundColor: "var(--yb-share-btn-bg-color)",
                    borderRadius: "56px",
                    minWidth: "260px",
                    fontSize: "14px",
                    padding: "8px 16px",
                    color: "white",
                  }}
                  onClick={toHome}
                >
                  <div className={"flex w-full items-center gap-[8px]"}>
                    <Logo
                      style={{
                        width: "24px",
                        height: "24px",
                        margin: "0px",
                      }}
                      alt=""
                    />
                    <div className={"w-full"}> {t("continue_conversation_with_ai")}</div>
                    <ChevronRight className={"text-white"}></ChevronRight>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
